import { render, staticRenderFns } from "./LayoutWizard.vue?vue&type=template&id=c360a464"
import script from "./LayoutWizard.vue?vue&type=script&lang=js"
export * from "./LayoutWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c360a464')) {
      api.createRecord('c360a464', component.options)
    } else {
      api.reload('c360a464', component.options)
    }
    module.hot.accept("./LayoutWizard.vue?vue&type=template&id=c360a464", function () {
      api.rerender('c360a464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutWizard.vue"
export default component.exports